import React, {useState, useEffect, useContext, createContext} from 'react'
import { getAuth, onAuthStateChanged } from "firebase/auth";
//import 'firebase/compat/auth';

const AuthContext = createContext();

export const UseAuth = () =>{
    return useContext(AuthContext);
}

// Only PrivateRoute.js and utils.js's userId() actually read auth state, and they're
// only reachable from these paths. Initializing Firebase Auth unconditionally here
// forces every page (including fully public ones) to wait on its iframe (~90KB,
// ~1s+) before rendering, for no benefit outside these routes.
const AUTH_RELEVANT_PATH_PREFIXES = ["/login", "/details", "/dots", "/dots-details", "/dashboard"];

const isAuthRelevantPath = (pathname) => {
    const path = (pathname || "").toString();
    return AUTH_RELEVANT_PATH_PREFIXES.some(
        (prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(`${prefix}?`)
    );
};

export const AuthProvider = ({children}) =>{
    const [authRelevant] = useState(() =>
        typeof window !== "undefined" ? isAuthRelevantPath(window.location.pathname) : false
    );
    const [user, setUser]  = useState(null)
    const [isAuthenticating, setIsAuthenticating] = useState(authRelevant)

    useEffect( () =>{
    if (!authRelevant) return undefined;
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      //if (user) {
       setUser(user);
       setIsAuthenticating(false);
     // }
    });

    return () => unsubscribe();
}, [authRelevant]);

const values = {
    user,
    isAuthenticating
}

return (
<AuthContext.Provider value = {values} >
    { !isAuthenticating && children}
</AuthContext.Provider>
);

};